import { combineReducers } from 'redux'

import authSlice from './auth/reducer'
import downloadSlice from './downloadFiles/reducer'
import sendSmsSlice from './sendSms/reducer'
import userSlice from './user/reducer'

export default combineReducers({
    auth: authSlice,
    user: userSlice,
    sms: sendSmsSlice,
    download: downloadSlice,
})
